import { useState } from 'react';
import { cambiaPassword } from '../../lib/sessione';
import { ErroreApi, ErroreRete } from '../../api/client';

/*  Il cambio della propria password.

    Due modi di comparire. OBBLIGATO: si è entrati con una password provvisoria, e questa
    schermata sta davanti a tutto il resto finché non è cambiata — con `obbligato` vero
    non c'è il bottone per annullare, perché non ci sarebbe niente dietro a cui tornare.
    VOLONTARIO: dal proprio nome in barra, e si può chiudere.

    La password nuova si scrive due volte. È l'unico controllo che conta davvero qui: una
    password che non si vede mentre si scrive, sbagliata una volta sola, chiude fuori chi
    la sta cambiando — e il rimedio è una telefonata in ufficio.

    Il minimo di caratteri è scritto a schermo PRIMA di provare, non dopo. Una regola che
    si scopre solo quando il server rifiuta fa scrivere tre password per trovarne una che
    passa, e la terza è sempre peggiore della prima.
*/
export function CambiaPassword({
  obbligato,
  onFatto,
  onAnnulla,
}: {
  obbligato: boolean;
  onFatto: () => void;
  onAnnulla?: () => void;
}) {
  const [vecchia, setVecchia] = useState('');
  const [nuova, setNuova] = useState('');
  const [ripetuta, setRipetuta] = useState('');
  const [errore, setErrore] = useState<string | null>(null);
  const [inCorso, setInCorso] = useState(false);

  const diverse = ripetuta.length > 0 && nuova !== ripetuta;

  async function salva(evento: React.FormEvent) {
    evento.preventDefault();

    if (nuova !== ripetuta) {
      setErrore('Le due password nuove non coincidono.');
      return;
    }

    setErrore(null);
    setInCorso(true);

    try {
      await cambiaPassword(vecchia, nuova);
      setVecchia('');
      setNuova('');
      setRipetuta('');
      onFatto();
    } catch (guasto) {
      setErrore(
        guasto instanceof ErroreRete
          ? 'TeraWorks non risponde: la password non è stata cambiata.'
          : guasto instanceof ErroreApi
            ? guasto.message
            : 'Cambio non riuscito.',
      );
      setInCorso(false);
    }
  }

  return (
    <div className="accesso">
      <form onSubmit={(e) => void salva(e)}>
        <h1>{obbligato ? 'Scegli la tua password' : 'Cambia password'}</h1>

        {obbligato && (
          <p className="nota">
            Quella con cui sei entrato è provvisoria: la conosce anche chi te l'ha data.
          </p>
        )}

        <label className="campo-blocco">
          <span>Password attuale</span>
          <input
            type="password"
            value={vecchia}
            onChange={(e) => setVecchia(e.target.value)}
            autoComplete="current-password"
            autoFocus
            required
          />
        </label>

        <label className="campo-blocco">
          <span>Password nuova</span>
          <input
            type="password"
            value={nuova}
            onChange={(e) => setNuova(e.target.value)}
            autoComplete="new-password"
            required
          />
        </label>

        <label className="campo-blocco">
          <span>Ripetila</span>
          <input
            type="password"
            value={ripetuta}
            onChange={(e) => setRipetuta(e.target.value)}
            autoComplete="new-password"
            aria-invalid={diverse}
            required
          />
        </label>

        {diverse && <p className="nota">Le due non coincidono ancora.</p>}
        {errore !== null && <p className="errore">{errore}</p>}

        <button type="submit" className="primario" disabled={inCorso || diverse}>
          {inCorso ? 'Salvataggio…' : 'Cambia password'}
        </button>

        {!obbligato && onAnnulla !== undefined && (
          <button type="button" onClick={onAnnulla}>
            Lascia stare
          </button>
        )}

        <p className="nota">
          Almeno dodici caratteri. Una frase corta va benissimo e si ricorda meglio di una
          parola con i simboli dentro.
        </p>
      </form>
    </div>
  );
}
